import Vue from 'vue';
import AppAccumulatedFee from '@/plugins/graphql/queries/v2/app-accumulated-fees.gql';
import AnimatedNumber from 'animated-number-vue';
import BillingPaymentStatus from '@/components/v2/BillingPaymentStatus.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import '@/assets/stylesheets/v2/_billing-widget.scss';
export default Vue.extend({
    components: {
        AnimatedNumber,
        BillingPaymentStatus,
    },
    mixins: [ViewportSizeMixin],
    apollo: {
        appAccumulatedFees: {
            query: AppAccumulatedFee,
            variables() {
                return {
                    appUuid: this.appUuid,
                };
            },
            update({ app }) {
                if (app) {
                    return app.accumulatedConvenienceFee;
                }
                return 0.0;
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            appAccumulatedFees: 0.0,
            duration: 2000,
        };
    },
    methods: {
        filterValue(value) {
            const options = this.$options;
            if (!!options && !!options.filters && !!options.filters.currency) {
                return options.filters.currency(value);
            }
            return '0.0';
        },
    },
    render(createElement) {
        const self = this;
        return createElement('v-card', { class: 'billing-widget', props: { flat: true } }, [
            createElement('v-layout', { class: 'column align-center justify-center pa-2' }, [
                createElement('v-layout', { class: 'align-center justify-space-between full-width' }, [
                    createElement('v-flex', { class: 'shrink' }, [
                        createElement('base-text', {
                            props: {
                                text: 'Accumulated Convenience Fees:',
                                fontSize10: self.mdAndUp,
                                lineHeight11: self.mdAndUp,
                                fontSize12: self.smAndDown,
                                lineHeight14: self.smAndDown,
                            },
                            class: 'mb-0 mr-2 font-weight-black',
                        }),
                    ]),
                    createElement('v-flex', { class: 'shrink' }, [
                        createElement('animated-number', {
                            props: {
                                value: self.appAccumulatedFees,
                                duration: self.duration,
                                formatValue: self.filterValue,
                                xs12: self.xsOnly,
                            },
                            class: {
                                'orange--text text--darken-3 font-weight-bold': true,
                                'font-size-16 line-height-19': self.mdAndUp,
                                'font-size-14 line-height-16': self.smAndDown,
                            },
                        }),
                    ]),
                ]),
                createElement('v-layout', { class: { 'full-width': true, 'text-xs-center': self.xsOnly } }, [createElement('billing-payment-status')]),
            ]),
        ]);
    },
});
